// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"caret-left"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14.5 5L14.5 19L7.5 12L14.5 5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14.5 5L14.5 19L7.5 12L14.5 5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CaretLeftIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'caret-left',
    ref,
    icon: element,
  },
));

CaretLeftIcon.displayName = 'CaretLeftIcon';

export default CaretLeftIcon;
